import type { Device, types } from 'mediasoup-client';
import Bowser from 'bowser';
import { TrackLabel } from '../types/common';

export const detectHandlerName = (userAgent?: string): types.BuiltinHandlerName | undefined => {
  const ua = userAgent ?? navigator?.userAgent;

  if (!ua) {
    return undefined;
  }

  const browser = Bowser.getParser(ua);

  if (browser.satisfies({ 'yandex browser': '>=25' }) && browser.getOSName() === 'iOS') {
    return undefined;
  }

  if (browser.satisfies({ 'yandex browser': '>=23.7' })) {
    return 'Chrome111';
  }

  if (browser.satisfies({ 'yandex browser': '>=22' })) {
    return 'Chrome74';
  }

  if (browser.satisfies({ 'Samsung Internet for Android': '>=17' })) {
    return 'Chrome111';
  }

  return undefined;
};

export const getNewAudioContext = (contextOptions?: AudioContextOptions): AudioContext | null => {
  const Context = window.AudioContext // Default
    || (window as unknown as { webkitAudioContext: unknown }).webkitAudioContext // Safari and old versions of Chrome
    || false;

  if (Context) {
    return new Context(contextOptions);
  }

  return null;
};

export const getSupportedCodecsMimeTypes = (device: Device): string[] => device
  .rtpCapabilities
  .codecs
  ?.reduce((acc: string[], codec: types.RtpCodecCapability) => {
    const preparedCodec = codec.mimeType?.toLowerCase();

    if (preparedCodec && !acc.includes(preparedCodec)) {
      acc.push(preparedCodec);
    }

    return acc;
  }, []) ?? [];

export const isVp9 = (codecOrMimeType: string): boolean => ['video/vp9', 'vp9'].includes(codecOrMimeType.toLowerCase());

export const isTrackLabel = (value: unknown): value is TrackLabel =>
  typeof value === 'string' && (Object.values(TrackLabel) as string[]).includes(value);